/**
 * Shared a11y-dialog instance provided by the theme vendor script
 * (cannabuilder-a11y-dialog → dist/a11y-dialog.js → window.A11yDialog).
 */
const A11yDialog = typeof window !== 'undefined' ? window.A11yDialog : undefined;

export default A11yDialog;
